import $ from 'jquery'

const InputMask = function(elemsOrSelector) {
  import(/* webpackChunkName: "assets/jsc/input-phone" */ './lazy')
    .then(InputMask => {
      InputMask.InputMask(elemsOrSelector)
    })
}

export default InputMask

if ($('input[name="phone"]').length) {
  InputMask('input[name="phone"]')
}

if ($('.js-input-mask').length) {
  InputMask('.js-input-mask')
}
